<section class="d-flex justify-content-between mt-2">
    <section class="btn-toolbar">
        <div class="ms-2">
            <p>Skæringsdato: </p>
        </div>
        <div class="ms-2">
            <app-date-picker-dk
                id="til"
                #til="ngModel"
                name="til"
                (ngModelChange)="onPeriodeChange($event, til.valid)"
                [ngModel]="periode">
            </app-date-picker-dk>
        </div>

        <div class="ms-2">
            <p>LA: </p>
        </div>
        <div ngbDropdown class="d-inline-block">
            <button class="btn btn-primary btn-sm btn--menu ms-2" id="laselect" ngbDropdownToggle>{{findLaName(this.laID) || 'Alle'}}</button>
            <div ngbDropdownMenu aria-labelledby="laselect">
                <button class="dropdown-item" (click)=onSelectLedelseAnsvarlig(null)>Alle</button>
                <button *ngFor="let medarbejder of laCards" (click)="onSelectLedelseAnsvarlig(medarbejder.cardId)" class="dropdown-item">{{medarbejder.fornavn}} {{medarbejder.efternavn}}</button>
            </div>
        </div>

        <div class="ms-2">
            <p>KA: </p>
        </div>
        <div ngbDropdown class="d-inline-block">
            <button class="btn btn-primary btn-sm btn--menu ms-2" id="kaselect" ngbDropdownToggle>{{findKaName(this.kaID) || 'Alle'}}</button>
            <div ngbDropdownMenu aria-labelledby="kaselect">
                <button class="dropdown-item" (click)=onSelectKundeAnsvarlig(null)>Alle</button>
                <button *ngFor="let medarbejder of kaCards" (click)="onSelectKundeAnsvarlig(medarbejder.cardId)" class="dropdown-item">{{medarbejder.fornavn}} {{medarbejder.efternavn}}</button>
            </div>
        </div>

        <div class="ms-2">
            <p>SA: </p>
        </div>
        <div ngbDropdown class="d-inline-block">
            <button class="btn btn-primary btn-sm btn--menu ms-2" id="saSelect" ngbDropdownToggle>{{findSaName(this.saID) || 'Alle'}}</button>
            <div ngbDropdownMenu aria-labelledby="saSelect">
                <button class="dropdown-item" (click)=onSelectSagsAnsvarlig(0)>Alle</button>
                <button *ngFor="let medarbejder of saCards" (click)="onSelectSagsAnsvarlig(medarbejder.cardId)" class="dropdown-item">{{medarbejder.fornavn}} {{medarbejder.efternavn}}</button>
            </div>
        </div>

        <div class="ms-2">
            <p>Koncern: </p>
        </div>
        <div ngbDropdown class="d-inline-block">
            <button class="btn btn-primary btn-sm btn--menu ms-2" id="koncernselect" ngbDropdownToggle>{{selectedKoncern || 'Alle'}}</button>
            <div ngbDropdownMenu aria-labelledby="koncernselect">
                <button (click)="onSelectKoncern(null)" class="dropdown-item">Alle</button>
                <button *ngFor="let koncern of koncerns" (click)="onSelectKoncern(koncern)" class="dropdown-item"> {{koncern}}</button>
            </div>
        </div>
    </section>
    <section class="btn-toolbar me-2">
        <div>
            <button (click)="onExport()" class="btn btn--menu btn-primary btn-sm" type="submit">Eksport</button>
        </div>
    </section>
</section>

